export default __webpack_public_path__ + "fbffcdcea4c9388c3290634ddb0f4502.webp";